module.exports = __webpack_public_path__ + "static/media/pesi.a8924d52.jpeg";